import React, { Component } from "react";
import {
  Button,
  Card,
  CircularProgress,
  Grid,
  TextField,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import "./loginView.css";
import { Product } from "../../../classes/types/product/product";
import { AuthHandler } from "../../../classes/methods/authMethods/authMethods";
import { Login } from "../../../classes/types/user/user";
import logo from "../../../assets/logo2.png";
import LoginEvent from "../../../classes/events/LoginEvent";

interface props {
  navigate: ReturnType<typeof useNavigate>;
}

interface state {
  products: Array<Product>;
  email: string;
  password: string;
  errorMessage: string;
  loading: boolean;
}

class LoginView extends Component<props, state> {
  _ismounted: any = false;
  constructor(props: props) {
    super(props);
    this.state = {
      products: [],
      email: "",
      password: "",
      errorMessage: "",
      loading: false,
    };
  }

  componentWillUnmount() {
    this._ismounted = false;
  }

  componentDidMount() {
    this._ismounted = true;
  }

  handleNavigateToHome = () => {
    this.props.navigate(`/`);
  };

  onPasswordChange = (e: any) => {
    this.setState({ password: e.target.value });
  };

  onEmailChange = (e: any) => {
    this.setState({ email: e.target.value });
  };

  onLogIN = () => {
    if (this._ismounted) {
      this.setState({ loading: true });
      const loginUser = new Login();
      loginUser.email = this.state.email;
      loginUser.password = this.state.password;

      AuthHandler.login(loginUser)
        .then(() => {
          LoginEvent.callLoginEvents();
          this.handleNavigateToHome();
          this.setState({ loading: false });
        })
        .catch(() => {
          this.setState({
            errorMessage:
              "Errore di accesso: si è verificato un errore durante il login assicurarsi di aver inserito i dati corretti.",
            loading: false,
          });
        });
    }
  };

  getIcon = () => {
    return this.state.loading ? (
      <CircularProgress size={24} style={{ color: "#fff" }} />
    ) : null;
  };

  render() {
    return (
      <Grid
        className="login-container"
        justifyContent="center"
        alignItems="center"
        container
      >
        <Card className="login-card">
          <div className="card-content">
            <div className="login-card-left">
              <img alt="logo" src={logo} />
              <h1 style={{ color: "#b3071b" }}>
                <span style={{ color: "white" }}>Benvenuti su </span>GIGABYTE
              </h1>
              <h3>
                Hai bisogno di un account? Contattaci{" "}
                <a href="mailto:info@gigabytedistribuzione.it">
                  info@gigabytedistribuzione.it
                </a>
              </h3>
            </div>
            <div className="login-card-right">
              <h1>Login</h1>
              <TextField
                className="textInput-size"
                onChange={this.onEmailChange}
                value={this.state.email}
                label="Email"
                variant="outlined"
              />
              <br />
              <br />
              <TextField
                className="textInput-size"
                onChange={this.onPasswordChange}
                type="password"
                value={this.state.password}
                label="Password"
                variant="outlined"
              />
              <br />
              <br />
              <span style={{ color: "red" }}>{this.state.errorMessage}</span>
              <br />
              <Button
                color="primary"
                variant="contained"
                onClick={this.onLogIN}
                startIcon={this.getIcon()}
                disabled={this.state.loading}
                className="login-button"
              >
                Accedi
              </Button>
            </div>
          </div>
        </Card>
      </Grid>
    );
  }
}

// --- Wrapper per React Router v6
export default function LoginViewWrapper(props: any) {
  const navigate = useNavigate();
  return <LoginView {...props} navigate={navigate} />;
}
